import React, { useEffect, useRef, useState } from "react";

import i18n from "i18next";

import { baseUrl } from "../../helpers/constants";
import { fetchWrapper } from "../../helpers/fetchwrapper";
import { IComment } from "../../Models/IComment";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  formats,
  hideToolbar,
  modules,
} from "../../helpers/reactQuillConstants";
import ExecuteDialog from "./ExecuteDialog";

//FLuent UI v.9
import { Checkbox, Tooltip } from "@fluentui/react-components";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import { InfoLabel } from "@fluentui/react-components/unstable";
import {
  Avatar,
  Button,
  FluentProvider,
  Link,
} from "@fluentui/react-components";
import {
  Dismiss24Regular,
  Dismiss24Filled,
  Add24Regular,
  DismissRegular,
} from "@fluentui/react-icons";
import { Delete24Regular } from "@fluentui/react-icons";

//import für Filterbox
import { SearchBox } from "@fluentui/react-search-preview";
import { Field, InputOnChangeData } from "@fluentui/react-components";
import { IAppUserDto } from "../../Models/IAppUserDto";
import authService from "../api-authorization/AuthorizeService";

interface ICommentsProps {
  comments: IComment[];
  context: string;
  refGuid1: string | undefined;
  refGuid2?: string | undefined;
  objectTitle: string;
  onCommentAdded: any;
}

function Comments(props: ICommentsProps) {
  const [commentGuid, setCommentGuid] = useState<string | undefined>("");
  const [comment, setComment] = useState<IComment>({ text: "" });
  const [currentUser, setCurrentUser] = useState<IAppUserDto>();
  const handleCommentChange = (name: string, val: any) => {
    setComment((prevState: any) => ({
      ...prevState,
      [name]: val,
    }));
  };
  //Status Solution Max 500 Zeichen
  const [commentMaxZeichenError, setCommentMaxZeichenError] = useState(false);

  //Temp Guid
  const [selectedGuid, setSelectedGuid] = useState<string | undefined>(
    undefined,
  );

  //Seiten Update State
  const [sideUpdate, setSideUpdate] = useState(false);

  useEffect(() => {
    setComment({
      context: props.context,
      refGuid1: props.refGuid1,
      refGuid2: props.refGuid2,
      objectTitle: props.objectTitle,
      text: "",
      notifyAll: false,
      delete: false,
    });
  }, [props.refGuid1, props.refGuid2]);

  const addComment = () => {
    fetchWrapper.post(`${baseUrl}/api/comment/AddComment`, comment).then(() => {
      setComment({
        context: props.context,
        refGuid1: props.refGuid1,
        refGuid2: props.refGuid2,
        objectTitle: props.objectTitle,
        text: "",
        notifyAll: false,
        delete: false,
      });
      props.onCommentAdded();
    });
  };

  const deleteComment = (guid: string) => {
    fetchWrapper
      .get(`${baseUrl}/api/comment/DeleteComment?guid=${guid}`)
      .then((result) => {
        if (result) {
          props.onCommentAdded();
        } else {
        }
      })
      .catch(() => {});
  };

  const getTimeStamp = (time: Date | undefined) => {
    if (time) {
      const now = new Date();

      const difference = now.getTime() - time.getTime(); // This will give difference in milliseconds
      const resultInMinutes = Math.round(difference / 60000);
      const resultInHours = Math.round(resultInMinutes / 60);

      if (resultInMinutes <= 1) {
        return i18n.t<string>("1minuteAgo");
      } else if (resultInMinutes > 0 && resultInMinutes < 60) {
        return i18n
          .t("minutesAgo")
          .replace("{minutes}", resultInMinutes.toString());
      } else if (resultInHours == 1) {
        return i18n.t<string>("1hourAgo");
      } else if (resultInHours >= 1 && resultInHours <= 24) {
        return i18n
          .t<string>("hoursAgo")
          .replace("{hours}", resultInHours.toString());
      } else {
        return time.toLocaleString();
      }
    } else {
      return "";
    }
  };

  //Status ob Quill-Editor an ist oder nicht
  const [answerComment, setAnswerCommet] = useState<IComment | undefined>(
    undefined,
  );

  //Refs Objekt in dem die Refs gespeichert werden von den Elementen
  const commentRefs = useRef(new Array());

  //für Filter
  const getHighlightedText = (text: string, highlight: string) => {
    //Trennt den HTML-Code von dem Text (Bsp. 1.[<p>] 2.[Test] 3.[</p>])
    const parts = text.split(new RegExp(`(<[^>]*>)`, "gi"));
    var tempText = "";
    var isHighlighted = false;
    //Geht die einzelnen parts durch parts= "<p>" oder "test"
    parts.map((part, i) => {
      if (!part.includes("<")) {
        //Wenn part nicht leer, dann nochmal teilen und tempText mit HTML-Code (<span>) füllen um zu highlighten
        //Wenn nicht gehighlighted, dann normal zurückgegeben
        if (part != "") {
          var splitPart = part.split(new RegExp(`(${highlight})`, "gi"));
          splitPart.map((p) => {
            if (p.toLowerCase() == highlight.toLowerCase()) {
              isHighlighted = true;
              tempText =
                tempText +
                '<span key="' +
                i +
                '" style="background: #FFF01F" >' +
                p +
                "</span>";
            } else {
              tempText = tempText + p;
            }
          });
        }
      } else {
        tempText = tempText + part;
      }
    });

    tempText = "<span>" + tempText + " </span>";
    if (isHighlighted) {
      return tempText;
    } else {
      return "";
    }
  };

  const [filterComment, setFilterComment] = useState("");
  const [filterComments, setFilterComments] = useState<any>([]);

  //Die Kommentare werden gefiltert und gehighlighted und werden zurückgegeben
  const getComments = () => {
    var tempComments = props.comments.map((item) => {
      return { ...item };
    });
    if (filterComment == "" || filterComment == "<") {
      setFilterComments(tempComments);
    } else {
      var comments = tempComments.map((comment: IComment) => {
        if (
          comment.text.toLowerCase().includes(filterComment.toLowerCase()) ||
          comment.createdBy?.fullName
            .toLowerCase()
            .includes(filterComment.toLowerCase())
        ) {
          if (filterComment != "") {
            comment.text = getHighlightedText(comment.text, filterComment);
            if (comment.text == "") {
            } else {
              return comment;
            }
          }
        }
      });
      setFilterComments(comments);
    }
  };
  const getCurrentUser = () => {
    authService.getUser().then((user) => {
      if (user) {
        fetchWrapper
          .getWithAuth(`${baseUrl}/api/account/getcurrentuser`)
          .then((result: IAppUserDto) => {
            setCurrentUser(result);
          })
          .catch((error) => {});
      }
    });
  };
  useEffect(() => {
    getCurrentUser();
    getComments();
  }, [props.comments]);

  useEffect(() => {
    getComments();
  }, [filterComment]);

  //---------------------Finaly-Return---------------------------

  return (
    <div className="lueb-ContentBlock" style={{ padding: "40px" }}>
      {currentUser != undefined && (
        <>
          <div>
            <ExecuteDialog
              isDialogOpen={selectedGuid != undefined}
              title={"Wollen sie den Kommentar löschen?"}
              subText={""}
              primaryButtonIconName={<Delete24Regular />}
              primaryButtonText={"löschen"}
              executeUrl={`${baseUrl}/api/comment/DeleteComment?guid=${selectedGuid}`}
              onDismiss={() => setSelectedGuid(undefined)}
              onExecute={() => {
                if (selectedGuid != undefined) {
                  deleteComment(selectedGuid);
                }
                setSelectedGuid(undefined);
                props.onCommentAdded();
              }}
              onError={() => setSelectedGuid(undefined)}
            />

            {/* ------Hinweis auf eine Antwort---- */}
            {answerComment && (
              <div>
                <div>
                  <div
                    style={{
                      border: "1px solid #ccc",
                      marginBottom: "5px",
                      background: "rgb(234 249 237)",
                      boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                      borderRadius: "6px",
                      padding: "8px",
                      paddingBottom: "0px",
                      paddingLeft: "5px",
                      paddingRight: "6px",
                      paddingTop: "8px",
                      overflow: "clip",
                    }}
                  >
                    <p
                      style={{
                        display: "inline",
                        color: "rgb(96, 94, 92)",
                        fontSize: "15px",
                        fontWeight: 600,
                      }}
                    >
                      Antwort auf Kommentar von{" "}
                      {answerComment.createdBy?.fullName}{" "}
                    </p>
                    <p
                      style={{
                        fontSize: "13px",
                        display: "inline",
                        color: "#adadad",
                        textAlign: "right",
                        marginBottom: "0px",
                        marginTop: "0px",
                        marginLeft: "5px",
                      }}
                    >
                      {answerComment.createdDate
                        ? getTimeStamp(new Date(answerComment.createdDate))
                        : ""}
                    </p>
                    <Button
                      style={{ float: "right" }}
                      appearance="transparent"
                      icon={<Dismiss24Filled />}
                      onClick={() => {
                        setAnswerCommet(undefined);
                        handleCommentChange("answerGuid", undefined);
                      }}
                    ></Button>
                    <ReactQuill
                      readOnly
                      modules={hideToolbar}
                      className={"ql-comment"}
                      style={{
                        minHeight: "20px",
                        maxHeight: "42px",
                        paddingTop: "0",
                        paddingLeft: "0px",
                        width: "100%",
                        background: "rgb(234 249 237)",
                        borderRadius: "8px",
                        paddingBottom: "3px",
                      }}
                      theme="snow"
                      value={answerComment.text}
                    />
                  </div>
                </div>
              </div>
            )}
            <ReactQuill
              className={"ql-comment-editor"}
              modules={modules}
              formats={formats}
              style={{
                marginBottom: "20px",
              }}
              theme="snow"
              value={comment.text}
              onChange={(value) => {
                if (value.length <= 1000) {
                  setCommentMaxZeichenError(false);
                  handleCommentChange("text", value ? value : "");
                } else {
                  setCommentMaxZeichenError(true);
                  setSideUpdate(!sideUpdate);
                }
              }}
            />

            {commentMaxZeichenError && (
              <p
                style={{
                  padding: 0,
                  margin: 0,
                  color: "rgb(164, 38, 44)",
                  fontSize: "15px",
                }}
              >
                Max. 1000 Zeichen
              </p>
            )}

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                appearance="primary"
                disabled={
                  comment.text.length == 0 ||
                  comment.text == "" ||
                  comment.text.replaceAll(" ", "") == "<p></p>" ||
                  comment.text.replaceAll(" ", "") == "<p><br></p>"
                }
                onClick={() => {
                  addComment();
                  //State wird auf undifined gesetzt, da der Kommentar abgesendet wird
                  setAnswerCommet(undefined);
                }}
              >
                {i18n.t<string>("addComment")}
              </Button>
              <Field>
                <SearchBox
                  style={{ width: "200px" }}
                  dismiss={
                    <Button
                      appearance="transparent"
                      icon={<DismissRegular />}
                      onClick={() => setFilterComment("")}
                    />
                  }
                  placeholder="Filter"
                  onChange={(ev: any, data: InputOnChangeData) => {
                    if (data) {
                      setFilterComment(data.value);
                    }
                  }}
                  value={filterComment}
                />
              </Field>
            </div>
          </div>
          <div
            style={{
              marginTop: "20px",
              overflowY: "scroll",
              height: "550px",
              boxShadow: "rgba(0, 0, 0, 0.06) 0px 2px 4px 0px inset",
            }}
          >
            <div style={{ marginTop: 20, marginBottom: 20 }}>
              {/* Hier werden die Kommentare gerednert */}
              {filterComments.map((comment: IComment) => {
                if (comment != undefined) {
                  const imageInitials = comment.createdBy?.fullName
                    ? comment.createdBy?.fullName[0]
                    : "";
                  const text = comment.createdBy?.fullName + " ";
                  const secondaryText = comment.createdBy?.firma;

                  return comment.delete ? (
                    <div
                      ref={(element) => {
                        if (element && !commentRefs.current.includes(element)) {
                          commentRefs.current.push(element);
                        }
                      }}
                      style={{
                        marginBottom: 20,
                      }}
                    >
                      <StackShim
                        horizontal
                        horizontalAlign={
                          currentUser.id == comment.createdBy?.id
                            ? "end"
                            : "start"
                        }
                        verticalAlign="center"
                      >
                        <div
                          style={{
                            borderRadius: "8px",
                            padding: "5px",
                            display: "inline-flex",
                          }}
                        >
                          <Avatar
                            name={text}
                            /* image={{
                                src: `${baseUrl}/api/user/GetThumbnailFoto?samAccountName=${comment.createdById}`,
                              }} */
                          />

                          <>
                            <div
                              onMouseLeave={() => {
                                setCommentGuid(undefined);
                              }}
                              onMouseOver={() => {
                                setCommentGuid(comment.guid);
                              }}
                              style={{
                                background:
                                  currentUser.id == comment.createdBy?.id
                                    ? "#FCEBDF"
                                    : "#f5f5f5",
                                float: "left",
                                boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",

                                borderRadius: "6px",
                                marginLeft: "-20px",
                                padding: "8px",
                                paddingBottom: "5px",
                                paddingLeft: "5px",
                                paddingRight: "7px",
                                paddingTop: "8px",
                              }}
                            >
                              <div
                                style={{
                                  marginLeft: "15px",
                                }}
                              >
                                <p
                                  style={{
                                    display: "inline",
                                    color: "rgb(96, 94, 92)",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                  }}
                                >
                                  {text + "  "}
                                </p>
                                {comment.guid == commentGuid && (
                                  <div
                                    style={{
                                      verticalAlign: "center",
                                      display: "inline",
                                    }}
                                  >
                                    <InfoLabel
                                      size="medium"
                                      info={
                                        <div>
                                          {" "}
                                          {i18n
                                            .t("userAddedComment")
                                            .replace("{user}", text ? text : "")
                                            .replace(
                                              "{objectTitle}",
                                              comment.objectTitle
                                                ? comment.objectTitle
                                                : "",
                                            )}
                                        </div>
                                      }
                                    ></InfoLabel>
                                  </div>
                                )}

                                <div
                                  style={{
                                    fontStyle: "italic",
                                    paddingTop: "0",
                                    paddingLeft: "2px",
                                    width: "100%",
                                    background:
                                      currentUser.id == comment.createdBy?.id
                                        ? "#FCEBDF"
                                        : "#f5f5f5",
                                    borderRadius: "8px",
                                  }}
                                >
                                  Dieser Kommentar wurde gelöscht
                                </div>
                              </div>
                            </div>
                          </>
                        </div>
                        {/* }
                      /> */}
                      </StackShim>
                    </div>
                  ) : (
                    <div
                      ref={(element) => {
                        if (element && !commentRefs.current.includes(element)) {
                          commentRefs.current.push(element);
                        }
                      }}
                      style={{
                        marginBottom: 20,
                      }}
                    >
                      <StackShim
                        horizontalAlign={
                          currentUser.id == comment.createdBy?.id
                            ? "end"
                            : "start"
                        }
                      >
                        <div
                          style={{
                            display: "inline-flex",
                            borderRadius: "8px",
                            padding: "5px",
                          }}
                        >
                          <div>
                            <Avatar
                              name={text}
                              /* image={{
                                src: `${baseUrl}/api/user/GetThumbnailFoto?samAccountName=${comment.createdById}`,
                              }} */
                            />
                          </div>

                          <div
                            onMouseLeave={() => {
                              setCommentGuid(undefined);
                            }}
                            onMouseOver={() => {
                              setCommentGuid(comment.guid);
                            }}
                          >
                            <div
                              style={{
                                width: "-webkit-fill-available",
                                background:
                                  currentUser.id == comment.createdBy?.id
                                    ? "#FCEBDF"
                                    : "#f5f5f5",
                                boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                                borderRadius: "6px",
                                marginLeft: "-20px",
                                /* padding: "8px", */
                                paddingBottom: "0px",
                                paddingLeft: "20px",
                                paddingRight: "20px",
                                paddingTop: "8px",
                              }}
                            >
                              <div
                                style={{
                                  marginLeft: "15px",
                                }}
                              >
                                <p
                                  style={{
                                    display: "inline",
                                    color: "rgb(96, 94, 92)",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                    marginRight: "10px",
                                  }}
                                >
                                  {text}
                                </p>
                                <p
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    display: "inline",
                                    color: "#787775",
                                  }}
                                >
                                  {comment.objectTitle}
                                </p>
                              </div>
                              {/* ------Hinweiß auf eine Antwort---- */}
                              {comment.answerGuid != undefined && (
                                <div>
                                  {props.comments.map((x, index) => {
                                    if (comment.answerGuid == x.guid) {
                                      return (
                                        <div>
                                          <div
                                            style={{
                                              margin: "5px",
                                              background: "rgb(234 249 237)",
                                              boxShadow:
                                                "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                                              borderRadius: "6px",
                                              padding: "8px",
                                              paddingBottom: "0px",
                                              paddingLeft: "5px",
                                              paddingRight: "6px",
                                              paddingTop: "8px",
                                              overflow: "clip",
                                              borderLeft: "green 3px solid",
                                            }}
                                          >
                                            <Link
                                              onClick={() => {
                                                commentRefs.current[
                                                  index
                                                ].scrollIntoView({
                                                  behavior: "smooth",
                                                  block: "start",
                                                  inline: "nearest",
                                                });
                                              }}
                                            >
                                              <p
                                                style={{
                                                  cursor: "pointer",
                                                  display: "inline",
                                                  color: "rgb(96, 94, 92)",
                                                  fontSize: "15px",
                                                  fontWeight: 600,
                                                }}
                                              >
                                                Antwort auf Kommentar von{" "}
                                                {x.createdBy?.fullName}{" "}
                                              </p>
                                            </Link>
                                            <p
                                              style={{
                                                fontSize: "13px",
                                                display: "inline",
                                                color: "#adadad",
                                                textAlign: "right",
                                                marginBottom: "0px",
                                                marginTop: "0px",
                                                marginLeft: "5px",
                                              }}
                                            >
                                              {x.createdDate
                                                ? getTimeStamp(
                                                    new Date(x.createdDate),
                                                  )
                                                : ""}
                                            </p>

                                            <ReactQuill
                                              readOnly
                                              modules={hideToolbar}
                                              className={"ql-comment"}
                                              style={{
                                                minHeight: "20px",
                                                maxHeight: "42px",
                                                paddingTop: "0",
                                                paddingLeft: "0px",
                                                width: "100%",
                                                background: "rgb(234 249 237)",
                                                borderRadius: "8px",
                                                paddingBottom: "3px",
                                              }}
                                              theme="snow"
                                              value={x.text}
                                            />
                                          </div>
                                        </div>
                                      );
                                    }
                                  })}
                                  {/* <div>
                                    <p
                                      style={{
                                        float: "right",
                                        cursor: "pointer",
                                      }}
                                    >
                                      Zum Kommentar
                                    </p>
                                  </div> */}
                                </div>
                              )}
                              {/* ---------------------------- */}
                              <div>
                                <ReactQuill
                                  readOnly
                                  modules={hideToolbar}
                                  className={"ql-comment"}
                                  style={{
                                    paddingTop: "0",
                                    paddingLeft: "2px",
                                    width: "100%",
                                    background:
                                      currentUser.id == comment.createdBy?.id
                                        ? "#FCEBDF"
                                        : "#f5f5f5",
                                    borderRadius: "8px",
                                  }}
                                  theme="snow"
                                  value={comment.text}
                                />
                              </div>
                              <StackShim
                                style={{ height: 30 }}
                                horizontalAlign={
                                  comment.guid == commentGuid &&
                                  currentUser.id == comment.createdBy?.id
                                    ? "space-between"
                                    : "end"
                                }
                                horizontal
                                verticalAlign="center"
                              >
                                {comment.createdBy?.id == currentUser.id &&
                                  comment.guid == commentGuid && (
                                    <div>
                                      <Button
                                        appearance="transparent"
                                        style={{
                                          color: "rgb(255, 102, 0)",
                                        }}
                                        icon={<Dismiss24Regular />}
                                        onClick={() => {
                                          setSelectedGuid(
                                            comment.guid
                                              ? comment.guid
                                              : undefined,
                                          );
                                        }}
                                      >
                                        Löschen
                                      </Button>
                                    </div>
                                  )}

                                {comment.createdBy?.id != currentUser.id &&
                                  comment.guid == commentGuid && (
                                    <Button
                                      appearance="transparent"
                                      style={{
                                        color: "rgb(255, 102, 0)",
                                      }}
                                      icon={<Add24Regular />}
                                      onClick={() => {
                                        setAnswerCommet(comment);
                                        handleCommentChange(
                                          "answerGuid",
                                          comment.guid,
                                        );
                                      }}
                                    >
                                      Antworten
                                    </Button>
                                  )}
                                <p
                                  style={{
                                    fontSize: "13px",
                                    display: "inline",
                                    color: "#adadad",
                                    textAlign: "right",
                                    marginBottom: "0px",
                                    marginTop: "0px",
                                  }}
                                >
                                  {comment.createdDate
                                    ? getTimeStamp(
                                        new Date(comment.createdDate),
                                      )
                                    : ""}
                                </p>
                              </StackShim>{" "}
                            </div>
                          </div>
                          {/* }
                      /> */}
                        </div>
                      </StackShim>
                    </div>
                  );
                }
              })}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Comments;
